import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HomepageVideoService } from 'src/app/services/homepage-video.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class HomePageVideoAddComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string;
  statuses: any = [];
  homepagevideoform: FormGroup;
  homepagevideostatus: boolean = true;
  notproduct: boolean = false;
  showUploadedpic: boolean = false;
  uploadedFiles: any[] = [];
  thumbNailImage: any[] = [];
  submitted: boolean = false;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  imageSize = 1000000;
  croppedImageMaxSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
transform: ImageTransform = {};

  constructor(private formBuilder: FormBuilder, private router: Router, private homePageVideoService: HomepageVideoService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.pagetitle = 'Add Home Page Video';
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.homepagevideoform = this.formBuilder.group({
      title: ['', [Validators.required]],
      status: [true, Validators.required],
      youtubechannelurl: ['', [Validators.required, Validators.pattern('^(https:\/\/www.youtube.com\/embed\/)(.*)')]],
      sequence:['',[Validators.required , Validators.pattern(/^[0-9]+$/)]]
    })
  }

  get f() {
    return this.homepagevideoform.controls;
  }

  onStatusSelect(event) {
    if (event) {
      this.homepagevideostatus = event.value;
    }
  }
    
  onFileSelect(event: any) {
    const file = event.files[0];
    if (!file) return;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    const fileEvent: any = {
      target: {
        files: [file]
      }
    };
    this.imageChangedEvent = fileEvent;
    this.cropDialog = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must be less than 1 MB.'
      : null;
  }
    
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.croppedImageError) return;
    const file = this.base64ToFile(
      this.croppedImage,
      this.selectedFile?.name || 'image.png'
    );
    if (file.size > this.croppedImageMaxSize) {
      this.croppedImageError = 'Cropped image size must be less than 1 MB.';
      return;
    }
    this.fileUpload.clear();
    const event = {
      files: [file]
    };
    this.picUploader(event);
    this.fileUpload.files = [file];
    this.cropDialog = false;
  }

  onCropCancel() {
    this.cropDialog = false;
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
    this.uploadedFiles = [];
    this.thumbNailImage = [];
  }
    
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
    this.onCropCancel();
  } 

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  picUploader(event) {
    if(this.thumbNailImage.length !== 0) {
      this.thumbNailImage = [];
    }
    //this.blogImage = [];
    this.notproduct = false;
    let index = 0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.thumbNailImage.push({ 'file': reader.result });
          index++;
        }
      }
    }
  }

  removeFile(event) {
    this.uploadedFiles = [];
    this.thumbNailImage = [];
  }

  onSubmit() {
    this.submitted = true;
    let addHomePageData = {};
    if (this.thumbNailImage.length === 0) {
      this.notproduct = true;
      return;
    } else {
      this.notproduct = false;
    }

    if (this.homepagevideoform.invalid) {
      return;
    }

    addHomePageData['title'] = this.homepagevideoform.value.title;
    addHomePageData['status'] = this.homepagevideoform.value.status;
    addHomePageData['youtubechannelurl'] = this.homepagevideoform.value.youtubechannelurl;
    addHomePageData['thumbNailImage'] = [{ file: this.thumbNailImage[0].file, alt: '', default: '' }];
    addHomePageData['sequence'] = this.homepagevideoform.value.sequence;

    addHomePageData = JSON.stringify(addHomePageData, null, 4);
    this.homePageVideoService.addHomePageVideo(addHomePageData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Home Page Video Added', life: 6000 });
      setTimeout(() => {
        this.router.navigate(['/manage/homepagevideo']);
      }, 2000);
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  backLink() {
    this.router.navigate(['/manage/homepagevideo']);
  }

   ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

    limitSequence(event: any) {
   let value = Number(event.target.value);
  if (value > 99) {
    value = 99;
    event.target.value = value;
    this.homepagevideoform.get('sequence')?.setValue(value);
  }

  }

  get cropDialogTitle(): string {
    return 'Crop & Adjust Thumbnail Image';
  }

  get cropDialogSubtitle(): string {
    return 'Position and scale image to fit mandatory 739 x 412 dimensions';
  }

  get cropPreviewLabel(): string {
    return '739 x 412 px';
  }
  zoomIn() {
    this.scale += 0.1;

    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    if (this.scale > 0.2) {
      this.scale -= 0.1;

      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }
  }

  resetZoom() {
    this.scale = 1;

    this.transform = {
      ...this.transform,
      scale: 1
    };
  }

}
